// 🔧 event_step.js
// ✅ Purpose: Event Builder pipeline step
// ✅ Features:
// - Executes the Event Builder
// - Creates standardized pipeline results
// - Updates DemoContext with the created event
// - Keeps pipeline logic separate from builder logic
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";
import { buildEventShell } from "../../builders/event_builder";

export const createEventStep = () => {
  return {
    name: "event_builder",

    label: "Event Builder",

    run: async (context) => {
      // Execute the Event Builder
      const eventResult = await buildEventShell(context);

      // Return a standardized pipeline result
      return createPipelineStepSuccess({
        step: "event_builder",
        label: "Event Builder",

        created: eventResult?.eventId ? 1 : 0,

        message: eventResult?.message,

        metadata: eventResult,

        startedAt: context.startedAt,
      });
    },

    afterSuccess: ({ result, sharedContext }) => {
      // Store the complete event result for downstream builders
      sharedContext.eventResult = result?.metadata || null;

      // Convenience reference
      sharedContext.event = result?.metadata || null;
    },
  };
};